import React from 'react';
import { Button } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import SchoolIcon from '@mui/icons-material/School';

import { endBriefingNewSession } from '../helpers/preFlightBriefing';
import { SESSION_EXPIRED } from '../utilities/enums';
import { Logout } from '../components';

import { BriefingTopics } from './BriefingTopics';

const actionButtonSx = {
  borderRadius: 2,
  textTransform: 'none',
  fontWeight: 700,
  px: 3,
  py: 1.5,
  minHeight: 52,
};

export const StatusPage = ({
  status,
  onTrainingModeChange,
  briefing,
  briefingIsNew,
  briefingOpen,
  briefingWasNew,
  onOpenBriefing,
  onCloseBriefing,
}) => {
  const isNoFlightsStatus = status && status.includes('No flights found');
  const showNew = briefingWasNew || briefingIsNew;

  if (status !== SESSION_EXPIRED && briefingOpen) {
    return (
      <div className="status-briefing-page">
        <header className="status-briefing-header">
          <Button
            variant="text"
            startIcon={<ArrowBackIcon />}
            onClick={onCloseBriefing}
            sx={{
              color: '#003d50',
              textTransform: 'none',
              fontWeight: 700,
            }}
          >
            Back
          </Button>
          <h1>
            Pre-flight Crew Briefing
            {showNew ? <span className="status-briefing-new">New</span> : null}
          </h1>
          <Logout />
        </header>
        <div className="status-briefing-scroll">
          <BriefingTopics topic={briefing} />
        </div>
      </div>
    );
  }

  return (
    <div className="status-page">
      {status === SESSION_EXPIRED ? (
        <>
          <div
            className="logout-container"
            onClick={() => {
              endBriefingNewSession();
              window.location.href = window.location.origin + '/login';
            }}
            style={{ marginLeft: '2px' }}
          >
            <span>LOGIN</span>
          </div>
          <h1 className="status-title">
            Your session has expired, please log in again
          </h1>
        </>
      ) : (
        <>
          <Logout />
          <h1 className="status-title"> {status}</h1>
          {isNoFlightsStatus && (
            <div className="status-page-actions">
              {onTrainingModeChange && (
              <Button
                variant="contained"
                color="primary"
                size="large"
                startIcon={<SchoolIcon />}
                disableElevation
                  sx={actionButtonSx}
                  onClick={onTrainingModeChange}
                >
                  Training
                </Button>
              )}
              <Button
                variant="contained"
                size="large"
                startIcon={<MenuBookIcon />}
                disableElevation
                onClick={onOpenBriefing}
                sx={{
                  ...actionButtonSx,
                  bgcolor: '#003d50',
                  '&:hover': { bgcolor: '#002838' },
                }}
              >
                Pre-flight Crew Briefing
                {briefingIsNew ? <span className="status-briefing-new">New</span> : null}
              </Button>
            </div>
          )}
        </>
      )}
    </div>
  );
};
